import React, { useEffect, useState } from 'react'
import { Chrono } from "react-chrono";
import { ASSET_URL } from '../../constant';

function History(props) {

    const [Items, setItems] = useState([])

    useEffect(() => {
        
        let itemDraft = [];

        if (props.data.length !== undefined) {
            
            for (let i = 0; i < props.data.length; i++) {

                if ( props.data[i].image !== null) {
                    
                    itemDraft[i] = {
                        title: props.data[i].year,
                        timelineContent: <p dangerouslySetInnerHTML={createMarkup(props.data[i].history)}></p>,
                        media: {
                            type: "IMAGE",
                            source: {
                                url: ASSET_URL + props.data[i].image
                            }
                        }
                    };

                } else {

                    itemDraft[i] = {
                        title: props.data[i].year,
                        timelineContent: <p dangerouslySetInnerHTML={createMarkup(props.data[i].history)}></p>,
                    };
                    
                }
                
            }
        }

        setItems(itemDraft)

    }, [props])

    function createMarkup(html) {
        return {__html: html}
    }

    return (
        <div id="timeline-history">
            {Items.length > 0 &&
                <Chrono
                    items={Items}
                    mode="HORIZONTAL"
                    mediaSettings={{ align: 'center', fit: 'contain' }}
                    focusActiveItemOnLoad={true}
                    hideControls={false}
                    disableNavOnKey
                    theme={{
                        primary: '#00498e',
                        secondary: '#00498e',
                        cardBgColor: 'white',
                        titleColor: 'black',
                        titleColorActive: 'white',
                    }}
                    classNames={{
                        card: 'my-card-history',
                    }}
                />
            }
        </div>
    )
}

export default History
